import { render, staticRenderFns } from "./SmBtnText.vue?vue&type=template&id=607603d0&scoped=true&"
import script from "./SmBtnText.vue?vue&type=script&lang=ts&"
export * from "./SmBtnText.vue?vue&type=script&lang=ts&"
import style0 from "./SmBtnText.vue?vue&type=style&index=0&id=607603d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607603d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
